import { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { LightTheme } from './themes/LightTheme';
import { ThemeInterface } from './ThemeInterface';
import { DarkTheme } from './themes/DarkTheme';

/**
 * StyledComponents用テーマ
 *
 * テーマは切り替えられる前提で設定することを意識すること
 *
 * AppTheme自体はいわゆるLightテーマを想定したパレットになっている。
 */
const NewsWebThemes = {
  light: LightTheme,
  dark: DarkTheme
} satisfies { [key: string]: ThemeInterface };

/**
 * DefaultThemeの拡張
 *
 * StyledComponentsの提供するDefaultTheme型を拡張することで、
 * 各コンポーネント内でテーマに対して型推論が有効になるようにする。
 *
 * プリミティブ型によってカラーコードまで分かるようにしているが、
 * Lightテーマでのカラーコードのみ表示される点だけ注意すること。
 *
 * @see https://qiita.com/Takepepe/items/eec6e1d2101570e7e241
 */
type AppTheme = typeof NewsWebThemes.light;
declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
  export interface DefaultTheme extends AppTheme {}
}

/**
 * NewsWeb用ThemeProvider
 *
 * 現時点でNewsWebはReactのエントリポイントが多いため、ThemeProviderを利用しないといけない箇所が多い。
 * テーマを動的に変えたいというような要望が来たときに取り回しが悪くなりすぎる可能性があるので、
 * NewsWeb内でThemeProviderを使うときはこのコンポーネントを使うようにする。
 *
 * @param props
 * @param props.children
 */
export const NewsWebThemeProvider = (props: { children: ReactNode }) => {
  // 当面はテーマの切り替えは発生しないのでLightテーマを固定であてる
  return <ThemeProvider theme={NewsWebThemes.light}>{props.children}</ThemeProvider>;
};
